import axios from "axios";
import React, { useEffect } from "react";
import Select from "react-select";

const CommonCustomerGet = ({
  customerList,
  setCustomerList,
  searchInput,
  setSearchInput,
  formik,
  setCustomerId,
}) => {
  const token = sessionStorage.getItem("token");
  // const companyId =sessionStorage.getItem("companyId")
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    getCustomerList();
  }, [searchInput]);

  const getCustomerList = () => {
    axios
      .post("/api/purple-fusion/customer/get", { name: searchInput }, headers)
      .then((res) => {
        setCustomerList(res.data);
        console.log(res.data);
      });
  };
  const sortedCustomerList = customerList.slice().sort((a, b) => b.id - a.id);

  return (
    <>
      <Select
        name="customer_id"
        options={sortedCustomerList.map((resstate) => ({
          label: resstate.name,
          value: resstate.id,
          //   gstnumber: resstate.gstnumber,
          //   vendorcode: resstate.vendorcode,
        }))}
        placeholder="Select Customer"
        className="bg-white-A700 border border-gray-200_02 border-solid h-9 rounded-[5px] text-sm w-full"
        value={
          formik.values.customer_id
            ? {
                label: sortedCustomerList.find(
                  (option) => option.id === formik.values.customer_id
                )?.name,
                value: formik.values.customername,
              }
            : null
        }
        onChange={(selectedOption) => {
          formik.setValues({
            ...formik.values,
            customer_id: selectedOption.value,
            // gstnumber: selectedOption.gstnumber,
            // vendorcode: selectedOption.vendorcode,
          });
          setCustomerId(selectedOption.value);
        }}
        onInputChange={setSearchInput}
        onBlur={formik.handleBlur}
      />
    </>
  );
};

export default CommonCustomerGet;
